import { Button } from '@avanta/shared/components/ui/Button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface TrainingCalendarNavButtonsProps {
  disablePrevious: boolean;
  disableNext: boolean;
  onPreviousClick: () => void;
  onNextClick: () => void;
}

export const TrainingCalendarNavButtons = ({
  disablePrevious,
  disableNext,
  onPreviousClick,
  onNextClick,
}: TrainingCalendarNavButtonsProps): React.ReactElement => (
  <div className="flex items-center gap-4 am-3xl:gap-2">
    <Button
      onClick={onPreviousClick}
      variant="secondary"
      size="md"
      icon="only"
      disabled={disablePrevious}
    >
      <ChevronLeft className="size-6 am-3xl:stroke-[1.5] stroke-[1.25]" />
    </Button>
    <Button onClick={onNextClick} variant="secondary" size="md" icon="only" disabled={disableNext}>
      <ChevronRight className="size-6 am-3xl:stroke-[1.5] stroke-[1.25]" />
    </Button>
  </div>
);
